// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__0D8Pj","description":"style_description__mtu0+"};